import styled from 'styled-components';

export const NotFoundPageStyled = styled.div`
  padding: 50px;
  text-align: center;
  color: ${(p) => p.theme.colors.blue.dark};
  font-size: 20px;
`;
